import React, { useRef, useState, useEffect, useMemo } from 'react';

import Icon, { ICON_TYPES } from '@components/Icon/Icon';

import {
  DEIPageDatepickerDIV,
  DEIPageDatepickerDatesDIV,
  DEIPageDatepickerDateBUTTON,
  DEIPageDatepickerBackBUTTON,
} from './DEIPageDatepicker.styles';

const DEIPageDatepicker = ({
  activeDateTitle,
  dates,
  onSelectDate,
}) => {
  const activeDateIndex = useMemo(
    () => dates.findIndex(({ title }) => title === activeDateTitle)
    , [activeDateTitle, dates]
  );

  const [position, setPosition] = useState(0);
  const [positions, setPositions] = useState(9999);

  const datepickerRef = useRef();

  useEffect(() => {
    const _positions = Array.from(datepickerRef.current.children).map(child => child.offsetLeft);
    setPositions(_positions);
  }, [dates]);

  return (
    <DEIPageDatepickerDIV>
      <DEIPageDatepickerBackBUTTON
        onClick={() => {
          const index = activeDateIndex <= 0 ? 0 : activeDateIndex - 1;
          onSelectDate(dates[index]);
          setPosition(positions[index]);
        }}
        className={position > 0 ? 'show' : ''}
      >
        <Icon type={ICON_TYPES["chevron-left"]} />
      </DEIPageDatepickerBackBUTTON>
      <DEIPageDatepickerDatesDIV>
        <div
          ref={datepickerRef}
          style={{ transform: `translateX(-${position}px)` }}
        >
          {dates.map((date, i) => (
            <DEIPageDatepickerDateBUTTON
              className={`font--text-S ${activeDateTitle === date.title ? 'is-active' : ''}`}
              key={date.title}
              onClick={e => {
                onSelectDate(date);
                setPosition(positions[i]);
              }}
            >
              {date.title}
            </DEIPageDatepickerDateBUTTON>
          ))}
        </div>
      </DEIPageDatepickerDatesDIV>
    </DEIPageDatepickerDIV>
  );
}

export default DEIPageDatepicker;
